import React from 'react';
import { useTranslation } from 'react-i18next';
import { TabsPanel } from '@dev/ee-components';
import { sanitizeStringForTranslation } from '@dev/ee-tools';
import { goBack } from 'redux-first-history';
import { useDispatch } from 'react-redux';
import { ViewCampaignsHeaderProps } from '../TargetCampaignsProps';

export const ViewCampaignsHeader = ({ name }: ViewCampaignsHeaderProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const breadcrumbsDisplay = name && t(sanitizeStringForTranslation(name), name);

    return (
        <div>
            <TabsPanel
                title={t('viewcampaignsbtn')}
                breadcrumbs={breadcrumbsDisplay}
                breadcrumbsOnClick={() => dispatch(goBack())}
            />
        </div>
    );
};
